import { render, staticRenderFns } from "./ForgetAccount.vue?vue&type=template&id=2187a7d6&scoped=true&"
import script from "./ForgetAccount.vue?vue&type=script&lang=js&"
export * from "./ForgetAccount.vue?vue&type=script&lang=js&"
import style0 from "./ForgetAccount.vue?vue&type=style&index=0&id=2187a7d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187a7d6",
  null
  
)

export default component.exports